import React, { useEffect } from "react";
import PropTypes from "prop-types";

import {
  LevelSelector,
  NotebookWrapper,
} from "@learningblocks/simulations/shared-components";
import { Utilities } from "@learningblocks/exp-constants";
const { TOUR_PROPERTIES } = Utilities;
import { MathJaxContext } from "better-react-mathjax";
import { HighlightWrapper } from "@learningblocks/storybook-components";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { Log } from "@learningblocks/shared-components/lib/EventLogger";
import { ModalHandler } from "@learningblocks/protocol-components";

import { PageTour } from "./PageTour";

import "./style.scss";

export function Home(props) {
  useEffect(() => {
    if (!props.levelSelectorData) {
      props.onSetLevel();
    }
  }, [props.levelSelectorData]);

  const renderContent = () => {
    if (props.showLevelSelector) return null;
    else return <NotebookWrapper scene={props.scene} />;
  };

  const handleJoyrideCallback = ({ action, index, status, lifecycle }) => {
    if (
      action === TOUR_PROPERTIES.NEXT &&
      index === props.stepIndex &&
      lifecycle === TOUR_PROPERTIES.COMPLETE
    ) {
      props.incrementTour();
    } else if (status === TOUR_PROPERTIES.FINISH) {
      props.endTour();
    } else if (action === TOUR_PROPERTIES.CLOSE) {
      props.endTour();
    }
  };
  return (
    <>
      {props.levelSelectorData && (
        <Modal className="levelModal" isOpen={props.showLevelSelector}>
          <LevelSelector
            title={props.levelSelectorData.title}
            levels={props.levelSelectorData.levels}
            default={props.levelSelectorData.default}
            onSetLevel={props.onSetLevel}
            buttonText={props.levelSelectorData.buttonText}
          />
        </Modal>
      )}
      <Log level={props.level}>
        <MathJaxContext
          config={{
            tex: {
              inlineMath: [
                ["$", "$"],
                ["\\(", "\\)"],
              ],
              packages: { "[+]": ["mhchem"] },
            },
            loader: {
              load: [
                "[tex]/mhchem", // Chemistry notation support
                "a11y/semantic-enrich", // Adds semantic information for screen readers
                "a11y/explorer", // Interactive exploration mode for accessibility
              ],
            },
            a11y: {
              speech: true, // Enables speech synthesis for mathematical expressions
              braille: true, // Provides braille output support for braille displays
              subtitles: true, // Shows subtitles/captions for mathematical content
              explorer: true, // Enables accessibility explorer for interactive navigation
              assistiveMml: true, // Generates assistive MathML markup for screen readers
            },
          }}
        >
          <ModalHandler modals={props.modals} />
          <PageTour handleJoyrideCallback={handleJoyrideCallback} />
          <HighlightWrapper />
          {renderContent()}
        </MathJaxContext>
      </Log>
    </>
  );
}

Home.propTypes = {
  /**
   * bool value to show level selector
   */
  showLevelSelector: PropTypes.bool.isRequired,
  /**
   * function to invoke when level is selected
   */
  onSetLevel: PropTypes.func.isRequired,
  /**
   *  function for ending tour
   */
  endTour: PropTypes.func,
  /**
   *  function to  incrementing stepIndex
   */
  incrementTour: PropTypes.func,
  /**
   *  index for Page tour
   */
  stepIndex: PropTypes.number,
  /**
   *  level object
   */
  level: PropTypes.number,
  /**
   *  modals object
   */
  modals: PropTypes.object,
};
